import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AdminNav from '../components/admin/AdminNav';
import SiteFooter from '../components/common/SiteFooter';

export default function HomePage() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center">
      {/* Navigation; AdminNav shows each role only its own links */}
      <AdminNav />

      {/* Hero Section */}
      <header className="bg-white w-full shadow p-6 text-center mb-6">
        <h1 className="flex justify-center"><img src="/logo-header-light.png" alt="Qercha" className="h-16 sm:h-24 w-auto max-w-full" /></h1>
        <p className="text-gray-600 mt-2">
          {t('home.tagline')}
        </p>
        <Link to="/GroupSearchAndJoin">
          <button className="mt-4 bg-green-600 text-white px-5 py-2 rounded hover:bg-green-700 transition">
            {t('home.joinGroup')}
          </button>
        </Link>
      </header>

      {/* How It Works Section */}
      <section className="bg-white w-full max-w-4xl shadow rounded p-6 mb-8">
        <h2 className="text-2xl font-bold mb-4 text-gray-800">{t('home.howItWorks')}</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="bg-gray-50 p-4 rounded shadow-sm">
            <h3 className="font-semibold text-gray-700 mb-2">{t('home.step1Title')}</h3>
            <p className="text-gray-600">
              {t('home.step1Body')}
            </p>
          </div>
          <div className="bg-gray-50 p-4 rounded shadow-sm">
            <h3 className="font-semibold text-gray-700 mb-2">{t('home.step2Title')}</h3>
            <p className="text-gray-600">
              {t('home.step2Body')}
            </p>
          </div>
          <div className="bg-gray-50 p-4 rounded shadow-sm">
            <h3 className="font-semibold text-gray-700 mb-2">{t('home.step3Title')}</h3>
            <p className="text-gray-600">
              {t('home.step3Body')}
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <SiteFooter />
    </div>
  );
}
